<div>
    <canvas  #canvas width="1000" height="800"></canvas>
</div>
<ng-template #invalid>
    <p *ngIf="!isFitOld">Age est supperieur a 18 ans </p>
    <p *ngIf="!(perimetreCranien > 0)">perimetreCranien invalid ! </p>
</ng-template>